/* eslint-disable */
import AudioPlay from "Assets/images/audio_play.svg";

const styles = {
  container: {
    width: (props: any) => (props.icon == AudioPlay ? "32px" : "48px"),
    height: (props: any) => (props.icon == AudioPlay ? "32px" : "48px"),
    position: "relative",
    cursor: "pointer",
    display: "inline-block",
    borderRadius: "50%",
    "&:hover": {
      backgroundColor: "rgba(8,95,229,0.2)",
    },
  },
  audioControl: {
    position: "absolute",
    top: "34%",
    left: (props: any) => (props.isPlaying ? "33%" : "36%"),
    textAlign: "center",
  },
  audioControlLarge: {
    position: "absolute",
    top: "34%",
    transform: "scale(0.7) translate(-14%, -18%)",
    left: (props: any) => (props.isPlaying ? "33%" : "36%"),
    textAlign: "center",
  },
  button: {
    backgroundColor: "Transparent",
    padding: "0px",
    border: "none",
    cursor: "pointer",
    overFlow: "hidden",
    outline: "none",
    color: "rgba(99, 115, 164, 0.5)",
    "&:focus": {
      outline: "solid rgb(8, 95, 229)",
    },
  },
};

export default styles;
